module.exports = __webpack_public_path__ + "img/41_11.93af4975.png";